<div class="ui-date-picker-time" [class.ui-date-picker-time--disabled]="disabled()">
  <div #column class="ui-date-picker-time__column" role="listbox" aria-label="Hours">
    @for (option of hours(); track option.value) {
      <button
        type="button"
        role="option"
        class="ui-date-picker-time__option"
        [class.ui-date-picker-time__option--selected]="option.value === selectedHour()"
        [attr.data-selected]="option.value === selectedHour()"
        [attr.aria-selected]="option.value === selectedHour()"
        [disabled]="disabled()"
        (click)="pickHour(option.value)"
      >
        {{ option.label }}
      </button>
    }
  </div>

  <div class="ui-date-picker-time__divider"></div>

  <div #column class="ui-date-picker-time__column" role="listbox" aria-label="Minutes">
    @for (option of minutes(); track option.value) {
      <button
        type="button"
        role="option"
        class="ui-date-picker-time__option"
        [class.ui-date-picker-time__option--selected]="option.value === minute()"
        [attr.data-selected]="option.value === minute()"
        [attr.aria-selected]="option.value === minute()"
        [disabled]="disabled()"
        (click)="pickMinute(option.value)"
      >
        {{ option.label }}
      </button>
    }
  </div>

  @if (hour12Format()) {
    <div class="ui-date-picker-time__divider"></div>

    <div class="ui-date-picker-time__periods" role="listbox" aria-label="AM or PM">
      @for (period of periods; track period) {
        <button
          type="button"
          role="option"
          class="ui-date-picker-time__option"
          [class.ui-date-picker-time__option--selected]="period === selectedPeriod()"
          [attr.aria-selected]="period === selectedPeriod()"
          [disabled]="disabled()"
          (click)="pickPeriod(period)"
        >
          {{ period === 'am' ? 'AM' : 'PM' }}
        </button>
      }
    </div>
  }
</div>
